import { render, staticRenderFns } from "./DirectDebit.vue?vue&type=template&id=8db73054"
var script = {}
import style0 from "./DirectDebit.vue?vue&type=style&index=0&id=8db73054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports